import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

const links = [
  { label: 'Sobre mí', href: '#sobre' },
  { label: 'Cursos', href: '#cursos' },
  { label: 'Mentorías', href: '#mentorias' },
  { label: 'Testimonios', href: '#testimonios' },
  { label: 'FAQ', href: '#faq' },
]

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40)
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <motion.nav
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50"
      style={{
        background: scrolled ? 'rgba(13,13,13,0.96)' : 'transparent',
        backdropFilter: scrolled ? 'blur(24px)' : 'none',
        borderBottom: scrolled ? '1px solid rgba(201,168,76,0.14)' : '1px solid transparent',
        transition: 'background 0.4s, border-color 0.4s, backdrop-filter 0.4s',
      }}
    >
      <div className="flex items-center justify-between px-[5vw] h-[72px]">
        {/* Brand */}
        <a
          href="#hero"
          className="font-display font-black text-[12px] tracking-[0.12em] uppercase mb-1"
          style={{ color: 'var(--gold)' }}
        >
          Aprende Con Dante
        </a>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="font-body text-[13px] tracking-[0.04em] transition-colors duration-200"
              style={{ color: 'var(--ink-2)' }}
              onMouseEnter={e => e.target.style.color = 'var(--gold)'}
              onMouseLeave={e => e.target.style.color = 'var(--ink-2)'}
            >
              {l.label}
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="flex items-center gap-4">
          <a
            href="#cursos"
            className="hidden md:flex items-center gap-2 px-[22px] py-[10px] font-display font-bold text-[12px] tracking-[0.1em] uppercase transition-all duration-200"
            style={{ border: '1px solid var(--gold)', color: 'var(--gold)' }}
            onMouseEnter={e => { e.currentTarget.style.background = 'var(--gold)'; e.currentTarget.style.color = '#000' }}
            onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--gold)' }}
          >
            Ver cursos
          </a>
          {/* Mobile hamburger */}
          <button
            className="md:hidden flex flex-col gap-[5px] p-2"
            onClick={() => setMenuOpen(o => !o)}
            aria-label="Menu"
          >
            {[0, 1, 2].map(i => (
              <motion.span
                key={i}
                className="block h-[1px] w-5"
                style={{ background: 'var(--gold)' }}
                animate={menuOpen
                  ? i === 0 ? { rotate: 45, y: 6 } : i === 2 ? { rotate: -45, y: -6 } : { opacity: 0 }
                  : { rotate: 0, y: 0, opacity: 1 }
                }
                transition={{ duration: 0.25 }}
              />
            ))}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden md:hidden"
            style={{ background: 'var(--bg-2)', borderTop: '1px solid var(--line)' }}
          >
            <div className="flex flex-col px-[5vw] py-6 gap-5">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  className="font-display font-semibold text-[14px] tracking-[0.08em] uppercase"
                  style={{ color: 'var(--ink-2)' }}
                  onClick={() => setMenuOpen(false)}
                >
                  {l.label}
                </a>
              ))}
              <a href="#cursos" className="btn-fill self-start mt-2" onClick={() => setMenuOpen(false)}>
                Ver cursos
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  )
}